<template>
  <div class="color-square" :style="{'backgroundColor': color}">
  </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'ColorDetail',
    props: {
        value: {
            required: false,
            default: _ => 'transparent',
        },
    },
    computed: {
        color() {
            const colorValue = _.get(this.value, 'value.value', 'transparent')
            return colorValue
        },
    },
}
</script>

<style scoped>
.color-square {
    width: 20px;
    height: 20px;
    border-radius: 3px;
}
</style>
